import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { StackItem } from 'ui/layout/StackItem'
import { Controller } from 'react-hook-form'
import { InputAdornment, TextField } from '@mui/material'
import { useFormContext } from 'react-hook-form'

const Amount: React.FC<{
  name: string
}> = ({ name }) => {
  const { t } = useTranslation()
  const { control, watch, setValue } = useFormContext()

  const watchValue = watch(name)

  useEffect(() => {
    if (!isNaN(watchValue) && !!watchValue) {
      setValue(name, watchValue * 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchValue])

  return (
    <StackItem label={t('請求金額')}>
      <Controller
        name={name}
        control={control}
        render={({ field, formState }) => (
          <TextField
            autoFocus={true}
            {...field}
            variant="outlined"
            placeholder="5000"
            error={!!formState.errors?.[name]}
            helperText={
              // NOTE: errorMessageの表示を優先
              formState.errors?.[name]?.message ??
              (Number(field.value) >= 10000 && t('桁数にご注意ください'))
            }
            fullWidth
            inputProps={{
              maxLength: 12, //NOTE: JavaScriptの整数の最大値を超えないように
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">{t('円')}</InputAdornment>
              ),
            }}
            autoComplete={'off'}
          />
        )}
      />
    </StackItem>
  )
}

export default Amount
